<ng-container *ngIf="machineTotalJobsList.length">
  <table
    matSort
    mat-table
    class="machine-total-jobs-table"
    [dataSource]="machineTotalJobsList"
    (matSortChange)="sortData($event)"
  >
    <ng-container matColumnDef="dateTimeWork">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <span class="total-jobs-item-head">finish at</span>
      </th>
      <td mat-cell *matCellDef="let job">
        <span class="total-jobs-item">{{ job.dateTimeWork }}</span>
      </td>
    </ng-container>
    <ng-container matColumnDef="fileName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <span class="total-jobs-item-head">file job</span>
      </th>
      <td mat-cell *matCellDef="let job">
        <span class="total-jobs-item">{{ job.fileName }}</span>
      </td>
    </ng-container>
    <ng-container matColumnDef="totalTimeAsHHmmss">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <span class="total-jobs-item-head">total time</span>
      </th>
      <td mat-cell *matCellDef="let job">
        <span class="total-jobs-item">
          {{ job.totalTimeAsHHmmss }}
        </span>
        <mat-icon
          class="physical-incoherence-icon"
          matTooltip="Phisical incoherence: original total time sent by machine is greater than the elapsed!"
          *ngIf="job.physicalIncoherent == true"
          >warning
        </mat-icon>
      </td>
    </ng-container>
    <ng-container matColumnDef="cutMetersAsString">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <span class="total-jobs-item-head">cut (m)</span>
      </th>
      <td mat-cell *matCellDef="let job">
        <span class="total-jobs-item">{{ job.cutMetersAsString }}</span>
      </td>
    </ng-container>
    <ng-container matColumnDef="creaseMetersAsString">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <span class="total-jobs-item-head">crease (m)</span>
      </th>
      <td mat-cell *matCellDef="let job">
        <span class="total-jobs-item">{{ job.creaseMetersAsString }}</span>
      </td>
    </ng-container>
    <ng-container matColumnDef="average">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <span class="total-jobs-item-head">cut+crease/time (m/h)</span>
      </th>
      <td mat-cell *matCellDef="let job">
        <span class="total-jobs-item">{{ job.average }}</span>
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
    <tr mat-row *matRowDef="let myRowData; columns: columnsToDisplay"></tr>
  </table>
</ng-container>
